export const isOnPrem =
	import.meta.env.PROD && import.meta.env.REACT_APP_IN_DOCKER === 'true'
